import "./index.css"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import React from "react"
import ReactDOM from "react-dom/client"
import { I18nextProvider } from "react-i18next"

import App from "./App"
import i18n from "./i18n"
import reportWebVitals from "./reportWebVitals"

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 10 * (60 * 1000),
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
                let message = error?.response?.data?.message
                let status = error?.response?.status
                console.log(message, status)
                /*if (status === 401 && message?.toLowerCase().includes("invalid jwt")) {
                    sessionStorage.clear()
                    localStorage.clear()
                    const REDIRECT_URL = "/login"
                    window.location.href = REDIRECT_URL
                }
                else {*/
                return 1
                //}
            },
            retryDelay: 1 * (60 * 1000),
            staleTime: 8 * (60 * 1000)
        }
    }
})
const rootElement= document.getElementById("root")   
if(rootElement){
    const root = ReactDOM.createRoot(rootElement)      
    root.render(
        <React.StrictMode>
            <QueryClientProvider client={ queryClient }>
                <I18nextProvider i18n={ i18n }>         
                    <App />
                </I18nextProvider>
            </QueryClientProvider>
        </React.StrictMode>
    )
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
